import { Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: `#${_ctx.cmpId} `
  }, null, 8, ["to"]);
}